import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const loginUser = async (email, password) => {
  const res = await API.post("/auth/login", {
    email: email.trim(),
    password: password.trim(),
  });
  return res.data;
};

export const registerUser = async (data) => {
  const res = await API.post("/auth/register", data);
  return res.data;
};

export const getUserProfile = async () => {
  const res = await API.get("/auth/me");
  return res.data;
};

export const forgotPassword = async (email) => {
  const res = await API.post("/auth/forgot-password", { email });
  return res.data;
};

export const resetPassword = async (token, newPassword) => {
  const res = await API.post("/auth/reset-password", {
    token,
    newPassword,
  });
  return res.data;
};

export default API;